import ReactGA from "react-ga4"

import { GA_MEASUREMENT_ID } from "./constants"

export const initAnalytics = () => {
    ReactGA.initialize(GA_MEASUREMENT_ID)
}

export const trackPageview = (path) => {
    ReactGA.send({ hitType: "pageview", page: path })
}

export const trackEvent = (name, params) => {
    ReactGA.event(name, params)
}
